import React from 'react';
import { connect } from 'react-redux';
import { login as keycloakLogin } from '../../auth/keycloak';
import { signOut } from '../../auth/logout';
import { getSession } from '../../selectors/authentication';

// Signed out: the three sign-in entry points. Signed in (any mode): the user's name and a
// "Déconnexion" button, and no sign-in link at all.
export const Header = ({ session, onSignOut }) => (
    <header id="mainHeader">
        <a className="linkHome" href="https://hiasecure.com" target="_blank" rel="noopener noreferrer">
            <img
                src="/hia-logo-full.png"
                alt="HIAsecure"
                style={{ height: "44px", width: "auto" }}
                onError={function (e) { e.target.onerror = null; e.target.src = '/showroom.png'; }}
            />
        </a>
        {session ? (
            <div className="headerSession">
                {session.displayName && <span className="headerUserName">{session.displayName}</span>}
                <button type="button" className="framedLink full headerLogout" onClick={() => onSignOut(session)}>
                    Déconnexion
                </button>
            </div>
        ) : (
            <div>
                <a href="/" className="framedLink">Connexion par ID</a>
                <a href="/qr-code" className="framedLink full">Connexion QR Code</a>
                {/* SEC-04-safe login mode: Authorization Code + PKCE (public client). */}
                <a href="/admin" className="framedLink full" onClick={(e) => { e.preventDefault(); keycloakLogin(); }}>Se connecter avec Keycloak</a>
            </div>
        )}
    </header>
);

const mapStateToProps = (state) => ({ session: getSession(state) });
const mapDispatchToProps = (dispatch) => ({ onSignOut: (session) => signOut(session, dispatch) });

export default connect(mapStateToProps, mapDispatchToProps)(Header);
